var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 153,
    viewBox: "0 0 155 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 20.9543 8.9543 12 20 12H135C146.046 12 155 20.9543 155 32V133C155 144.046 146.046 153 135 153H20C8.9543 153 0 144.046 0 133V32ZM18.0835 33.5C18.0835 29.3579 21.4414 26 25.5835 26H129.417C133.559 26 136.917 29.3579 136.917 33.5C136.917 37.6421 133.559 41 129.417 41H25.5835C21.4414 41 18.0835 37.6421 18.0835 33.5ZM28 55C22.4772 55 18 59.4772 18 65V125C18 130.523 22.4772 135 28 135H127C132.523 135 137 130.523 137 125V65C137 59.4772 132.523 55 127 55H28Z",
    fill: "#EF4443"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 23,
    width: 23,
    height: 15,
    rx: 7.5,
    transform: "rotate(-90 31 23)",
    fill: "#6F6F6F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 89,
    width: 21,
    height: 21,
    rx: 10,
    transform: "rotate(-90 31 89)",
    fill: "#6F6F6F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 124,
    width: 21,
    height: 21,
    rx: 10,
    transform: "rotate(-90 31 124)",
    fill: "#6F6F6F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 89,
    width: 21,
    height: 21,
    rx: 10,
    transform: "rotate(-90 67 89)",
    fill: "#6F6F6F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 124,
    width: 21,
    height: 21,
    rx: 10,
    transform: "rotate(-90 67 124)",
    fill: "#6F6F6F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 89,
    width: 21,
    height: 21,
    rx: 10,
    transform: "rotate(-90 104 89)",
    fill: "#EF4443"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 124,
    width: 21,
    height: 21,
    rx: 10,
    transform: "rotate(-90 104 124)",
    fill: "#6F6F6F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 23,
    width: 23,
    height: 15,
    rx: 7.5,
    transform: "rotate(-90 109 23)",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActCalendar);
export default __webpack_public_path__ + "static/media/act-calendar.1c6f2a9d179382c5c2115a41829fb0e1.svg";
export { ForwardRef as ReactComponent };